<template>
  <div class="common__pageBody__1Dn3a" style="">
    <div class="preferentialActivity__promoPage__yhEHq">
      <div class="preferentialActivity__activityBox__3o22k" style="background-image: url('/static/image/b70ef7d781664dcf8ba63f2d7141f939.jpg'); background-repeat: repeat-y; background-size: 100%">
        <img src="/static/image/2241be3282a94d84b76fbd35fcf3aae8.png" width="1920px" class="preferentialActivity__imgBanner__2nt2m" style="" />
        <div class="preferentialActivity__innerBox__1svDM">
          <div class="preferentialActivity__content__UMK1C undefined">
            <div>
              <ul class="preferentialActivity__tab__3e2JQ">
                <li :class="actType == '' ? 'preferentialActivity__active__3GZpm' : ''" @click="changActType('')"><img :src="imgList[0]" height="unknow" style="" />全部优惠</li>
                <li :class="actType == item.id ? 'preferentialActivity__active__3GZpm' : ''" @click="changActType(item.id)" v-for="(item, index) in activitytypeList" :key="index"><img :src="imgList[index + 1]" height="unknow" style="" />{{ item.name }}</li>
              </ul>
            </div>
            <div class="preferentialActivity__wrap__1LC3I undefined">
              <ul class="preferentialActivity__acyivityList__3l7jF common__clearfix__28XIR">
                <li v-for="(item, index) in activitylistList" :key="index" @click="$parent.goNav(`/activityInfo?id=${item.id}`)">
                  <img src="/static/image/zx.24788ea9a4c53a563601b90cc69e94da.png" width="unknow" class="preferentialActivity__activityTag__2AF1_" style="" />
                  <div class="preferentialActivity__imgBox__FENnL undefined">
                    <p><img :src="item.banner" width="360px" height="224px" style="" /></p>
                    <div class="preferentialActivity__itemText__1l0uB">
                      <p class="preferentialActivity__title__oKsn_" :title="item.title">{{ item.title }}</p>
                      <p class="preferentialActivity__time__2SVJC">
                        <span>{{ item.created_at }}</span>
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'activity',
  data() {
    return {
      activitytypeList: [],
      actType: '',
      activitylistList: [],
      imgList: ['/static/image/11.png', '/static/image/22.png', '/static/image/33.png', '/static/image/44.png', '/static/image/55.png', '/static/image/66.png', '/static/image/77.png', '/static/image/88.png'],
    };
  },
  created() {
    let that = this;
    that.activitytype();
    that.activitylist();
  },
  methods: {
    activitytype() {
      let that = this;
      that.$apiFun.post('/api/activitytype', {}).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitytypeList = res.data;
        }
      });
    },
    activitylist() {
      let that = this;
      let info = that.actType == '' ? {} : { type: that.actType };
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitylist', info).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitylistList = res.data.data;
        }
        that.$parent.hideLoading();
      });
    },
    changActType(val) {
      let that = this;
      if (val == that.actType) {
        return;
      }
      that.actType = val;
      that.activitylist();
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/PreferentialActivity_81ba8019.baf1e0c1.css';
</style>



// WEBPACK FOOTER //
// src/components/mode/activity.vue